import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
document.body.style = 'background: #383838;';
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
